module.exports = {
  "mode": "compressed",
  "staticDomainPrefix": "//static.hsappstatic.net",
  "bender": {
    "depVersions": {
      "conversations-embed": "static-1.27523",
      "conversations-internal-schema": "static-1.13202",
      "head-dlb": "static-1.5007",
      "hs-test-utils": "static-1.8183",
      "hubspot-url-utils": "static-1.4254",
      "HubStyleTokens": "static-2.11632",
      "I18n": "static-7.1643",
      "jasmine-runner": "static-1.6618",
      "quartz": "static-1.7240",
      "react": "static-7.188",
      "reselect": "static-3.7",
      "sinon": "static-1.9",
      "StyleGuideUI": "static-3.490",
      "webpack-env": "static-1.54",
      "visitor-ui-component-library": "static-1.6301",
      "enviro": "static-4.455",
      "hs-promise-rejection-tracking": "static-1.5587",
      "PortalIdParser": "static-2.404",
      "raven": "static-3.5925",
      "raven-hubspot": "static-1.6232",
      "bend-plugin-trellis-migration": "static-1.3517",
      "moment": "static-3.26",
      "customer-data-email": "static-1.18340",
      "cv-backend-services": "static-1.1584",
      "hub-http": "static-1.6382",
      "immutable": "static-2.82",
      "immutable-less": "static-1.4812",
      "quartz-config": "static-1.1018",
      "quartz-core": "static-1.6459",
      "transmute": "static-2.85",
      "HeadJS": "static-2.775",
      "react-dom": "static-7.85",
      "foundations-components": "static-1.8254",
      "framer-motion": "static-1.74",
      "hs-test-utils-bend-plugin": "static-1.3294",
      "msw": "static-1.39",
      "react-redux": "static-7.74",
      "redux": "static-4.16",
      "testing-library": "static-1.154",
      "foundations-theming": "static-1.4598",
      "i18n-data": "static-1.224",
      "metrics-js": "static-1.9801",
      "moment-timezone": "static-5.85",
      "react-utils": "static-2.5457",
      "jasmine": "static-4.4486",
      "csstype": "static-1.50",
      "hoist-non-react-statics": "static-3.9",
      "PatternValidationJS": "static-1.437",
      "react-aria": "static-1.68",
      "styled-components": "static-2.92",
      "UIComponents": "static-3.8578",
      "visitor-ui-component-library-icons": "static-1.6112",
      "bender-build-tools": "static-1.3301",
      "apollo-dlb": "static-3.86",
      "apollo-link-hub-http": "static-2.4813",
      "apollo-stack-hubspot": "static-3.88",
      "classnames": "static-2.10",
      "cssUtils": "static-1.838",
      "customer-data-objects": "static-1.7840",
      "customer-data-ui-utilities": "static-1.9984",
      "data-fetching-client": "static-1.9821",
      "FileManagerCore": "static-1.39608",
      "FileManagerLib": "static-1.39749",
      "foundations-assets": "static-1.5035",
      "graphql": "static-1.84",
      "hs-promise-utils": "static-1.5756",
      "hubspot-apollo-client": "static-1.5040",
      "icons": "static-2.660",
      "react-immutable-proptypes": "static-2.8",
      "react-immutable-render-mixin": "static-1.9",
      "react-input-autosize": "static-2.17",
      "react-select-plus": "static-1.107",
      "react-virtualized": "static-2.101",
      "rpc-client-utils": "static-1.4821",
      "salesImages": "static-1.528",
      "timezone-utils": "static-2.5404",
      "ui-gdpr-components": "static-1.10512",
      "ts-schema": "static-1.4198",
      "hs-locale-management": "static-1.198",
      "hs-lodash": "static-4.45",
      "immer": "static-1.33",
      "dispatcher": "static-1.140",
      "general-store": "static-6.20",
      "hub-http-janus": "static-1.850",
      "hubspotter-http": "static-1.4767",
      "mobile-manifest-mixins": "static-1.549",
      "module-federation": "static-1.28",
      "quartz-auth": "static-1.915",
      "quartz-head": "static-1.905",
      "quartz-i18n": "static-1.915",
      "quartz-routing": "static-1.670",
      "quartz-test": "static-1.915",
      "quartz-tracking": "static-1.619",
      "quick-fetch": "static-1.4033",
      "react-rhumb": "static-1.16860",
      "trellis-components": "static-1.2279",
      "ui-fonts": "static-1.894",
      "usage-tracker-container": "static-1.7503",
      "usage-tracker-core": "static-1.7363",
      "bend-plugin-foundations-components": "static-1.4523",
      "floating-ui": "static-1.59",
      "foundations-theming-specialty": "static-1.2314",
      "hs-story-utils": "static-1.9585",
      "react-create-root-preference": "static-1.41",
      "tanstack-table": "static-1.57",
      "trellis-assets": "static-1.2260",
      "ui-images": "static-2.1198",
      "bend-plugin-foundations-theming": "static-1.3081",
      "foundations-theming-base": "static-1.3583",
      "stylex": "static-1.36",
      "HubStyle": "static-2.11939",
      "sassPrefix": "static-1.159",
      "inbound-db-properties-service-client": "static-1.3963",
      "property-translator": "static-1.5557",
      "react-dnd-compat": "static-1.4775",
      "fast-json-stable-stringify": "static-1.4",
      "ai-components-ui-library": "static-1.9375",
      "audio-components": "static-1.6166",
      "ContentUtils": "static-1.68858",
      "cropperjs": "static-1.10",
      "feedback-loader": "static-1.29605",
      "file-manager-components": "static-1.24109",
      "FileManagerImages": "static-1.37260",
      "foundations-components-legacy": "static-1.1279",
      "html-to-image": "static-1.56",
      "immerable": "static-1.4312",
      "react-colorpicker": "static-2.10370",
      "redux-toolkit": "static-1.7",
      "ui-universal-auth": "static-1.9170",
      "urlinator": "static-1.4695",
      "video-components": "static-1.13832",
      "video-data-lib": "static-1.35488",
      "video-embed": "static-1.36322",
      "redux-thunk": "static-2.43",
      "hubspot-apollo-cache": "static-1.499",
      "bend-plugin-chirp-manifest": "static-1.231",
      "chirp-fetch": "static-1.2050",
      "hub-http-shared-msw-handlers": "static-1.10375",
      "hubspotter-http-shared-msw-handlers": "static-1.10373",
      "usage-tracker-session-replay": "static-1.5199",
      "web-vitals": "static-1.8",
      "base-ui": "static-1.16",
      "react-day-picker": "static-1.5",
      "trellis-theming": "static-1.1109",
      "tanstack-virtual": "static-1.32",
      "react-dnd": "static-5.6",
      "react-dnd-html5-backend": "static-5.6",
      "autolinker": "static-3.11",
      "chatspot-core": "static-1.22130",
      "copilot-toolkit": "static-1.11564",
      "customer-data-objects-ui-components": "static-1.13191",
      "sanitize": "static-1.4638",
      "sanitize-text": "static-1.8308",
      "content-assistance-lib": "static-1.8009",
      "usage-tracker": "static-1.7513",
      "cms-field-types": "static-1.4975",
      "content-icons-ui": "static-1.2274",
      "integrations-lib": "static-1.16695",
      "underscore": "static-1.8",
      "breeze-engine-lib": "static-1.1309",
      "ui-addon-iframeable": "static-1.9239",
      "video-components-external": "static-1.11830",
      "unified-auth-core-lib": "static-1.966",
      "social-insights-client-types": "static-1.22517",
      "SharedI18nStrings": "static-1.182",
      "outpost": "static-1.4330",
      "amplitude-session-replay-browser": "static-1.60",
      "markdown-it": "static-1.6",
      "magpie-lib": "static-1.5658",
      "magpie-types": "static-1.5118",
      "simple-logging-lib": "static-1.3210",
      "atom": "static-1.5236",
      "avatar-components": "static-1.2661",
      "reference-resolvers": "static-1.8337",
      "superstore": "static-1.4921",
      "ui-addon-video-player": "static-1.8866",
      "ui-coaching-tips": "static-1.29030",
      "flux-actions": "static-1.350",
      "frontend-preferences-client": "static-1.8089",
      "integrations-error-boundary-lib": "static-1.14110",
      "integrations-tracking-lib": "static-1.5769",
      "laboratory-lib": "static-3.7312",
      "native-integrations-shared-strings": "static-1.7941",
      "redux-observable": "static-1.11",
      "ReduxMessenger": "static-2.10524",
      "rxjs": "static-5.10",
      "ui-addon-i18n": "static-1.11310",
      "ui-shepherd-react": "static-3.10420",
      "unified-auth": "static-1.684",
      "breeze-engine-core": "static-1.587",
      "ably": "static-2.2",
      "highlight.js": "static-1.81",
      "navigation-messaging": "static-1.7785",
      "content-media-composition-data-lib": "static-1.12851",
      "content-media-compositions": "static-2.16858",
      "idb-keyval": "static-1.46",
      "media-bridge-lib": "static-1.19216",
      "fsm": "static-1.3891",
      "reactive-lib": "static-1.887",
      "growth-onboarding-feedback-components": "static-1.6740",
      "universal-page-editor-lib": "static-1.3173",
      "foundations-components-test-utils": "static-1.5737",
      "adobe-sign-auth-lib": "static-1.174",
      "ads-unified-auth-lib": "static-1.652",
      "google-sheets-integration-lib": "static-1.739",
      "microsoft-drive-integration-lib": "static-1.878",
      "surveymonkey-integration-lib": "static-1.192",
      "slack-ui-library": "static-1.10558",
      "js-cookie": "static-1.18",
      "react-dlb": "static-1.82",
      "crm-record-cards-service-types": "static-1.3702",
      "framework-data-schema-resolvers": "static-1.7057",
      "location-customization-utils-lib": "static-1.9753",
      "batch-promise": "static-1.1705",
      "conditional-properties-service-client": "static-1.3914",
      "crm-pipelines-api-client-types": "static-1.4254",
      "fdsr-migration-layer": "static-1.176",
      "framework-builder-read-service-client": "static-1.4122",
      "framework-data-schema-quick-fetch": "static-1.6962",
      "inbound-db-meta-service-client": "static-1.3704",
      "multi-currency-client-types": "static-1.3808",
      "persist-promise": "static-1.3862"
    },
    "depPathPrefixes": {
      "conversations-embed": "/conversations-embed/static-1.27523",
      "conversations-internal-schema": "/conversations-internal-schema/static-1.13202",
      "head-dlb": "/head-dlb/static-1.5007",
      "hs-test-utils": "/hs-test-utils/static-1.8183",
      "hubspot-url-utils": "/hubspot-url-utils/static-1.4254",
      "HubStyleTokens": "/HubStyleTokens/static-2.11632",
      "I18n": "/I18n/static-7.1643",
      "jasmine-runner": "/jasmine-runner/static-1.6618",
      "quartz": "/quartz/static-1.7240",
      "react": "/react/static-7.188",
      "reselect": "/reselect/static-3.7",
      "sinon": "/sinon/static-1.9",
      "StyleGuideUI": "/StyleGuideUI/static-3.490",
      "webpack-env": "/webpack-env/static-1.54",
      "visitor-ui-component-library": "/visitor-ui-component-library/static-1.6301",
      "enviro": "/enviro/static-4.455",
      "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
      "PortalIdParser": "/PortalIdParser/static-2.404",
      "raven": "/raven/static-3.5925",
      "raven-hubspot": "/raven-hubspot/static-1.6232",
      "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3517",
      "moment": "/moment/static-3.26",
      "customer-data-email": "/customer-data-email/static-1.18340",
      "cv-backend-services": "/cv-backend-services/static-1.1584",
      "hub-http": "/hub-http/static-1.6382",
      "immutable": "/immutable/static-2.82",
      "immutable-less": "/immutable-less/static-1.4812",
      "quartz-config": "/quartz-config/static-1.1018",
      "quartz-core": "/quartz-core/static-1.6459",
      "transmute": "/transmute/static-2.85",
      "HeadJS": "/HeadJS/static-2.775",
      "react-dom": "/react-dom/static-7.85",
      "foundations-components": "/foundations-components/static-1.8254",
      "framer-motion": "/framer-motion/static-1.74",
      "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3294",
      "msw": "/msw/static-1.39",
      "react-redux": "/react-redux/static-7.74",
      "redux": "/redux/static-4.16",
      "testing-library": "/testing-library/static-1.154",
      "foundations-theming": "/foundations-theming/static-1.4598",
      "i18n-data": "/i18n-data/static-1.224",
      "metrics-js": "/metrics-js/static-1.9801",
      "moment-timezone": "/moment-timezone/static-5.85",
      "react-utils": "/react-utils/static-2.5457",
      "jasmine": "/jasmine/static-4.4486",
      "csstype": "/csstype/static-1.50",
      "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
      "PatternValidationJS": "/PatternValidationJS/static-1.437",
      "react-aria": "/react-aria/static-1.68",
      "styled-components": "/styled-components/static-2.92",
      "UIComponents": "/UIComponents/static-3.8578",
      "visitor-ui-component-library-icons": "/visitor-ui-component-library-icons/static-1.6112",
      "bender-build-tools": "/bender-build-tools/static-1.3301",
      "apollo-dlb": "/apollo-dlb/static-3.86",
      "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4813",
      "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.88",
      "classnames": "/classnames/static-2.10",
      "cssUtils": "/cssUtils/static-1.838",
      "customer-data-objects": "/customer-data-objects/static-1.7840",
      "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9984",
      "data-fetching-client": "/data-fetching-client/static-1.9821",
      "FileManagerCore": "/FileManagerCore/static-1.39608",
      "FileManagerLib": "/FileManagerLib/static-1.39749",
      "foundations-assets": "/foundations-assets/static-1.5035",
      "graphql": "/graphql/static-1.84",
      "hs-promise-utils": "/hs-promise-utils/static-1.5756",
      "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5040",
      "icons": "/icons/static-2.660",
      "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
      "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
      "react-input-autosize": "/react-input-autosize/static-2.17",
      "react-select-plus": "/react-select-plus/static-1.107",
      "react-virtualized": "/react-virtualized/static-2.101",
      "rpc-client-utils": "/rpc-client-utils/static-1.4821",
      "salesImages": "/salesImages/static-1.528",
      "timezone-utils": "/timezone-utils/static-2.5404",
      "ui-gdpr-components": "/ui-gdpr-components/static-1.10512",
      "ts-schema": "/ts-schema/static-1.4198",
      "hs-locale-management": "/hs-locale-management/static-1.198",
      "hs-lodash": "/hs-lodash/static-4.45",
      "immer": "/immer/static-1.33",
      "dispatcher": "/dispatcher/static-1.140",
      "general-store": "/general-store/static-6.20",
      "hub-http-janus": "/hub-http-janus/static-1.850",
      "hubspotter-http": "/hubspotter-http/static-1.4767",
      "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.549",
      "module-federation": "/module-federation/static-1.28",
      "quartz-auth": "/quartz-auth/static-1.915",
      "quartz-head": "/quartz-head/static-1.905",
      "quartz-i18n": "/quartz-i18n/static-1.915",
      "quartz-routing": "/quartz-routing/static-1.670",
      "quartz-test": "/quartz-test/static-1.915",
      "quartz-tracking": "/quartz-tracking/static-1.619",
      "quick-fetch": "/quick-fetch/static-1.4033",
      "react-rhumb": "/react-rhumb/static-1.16860",
      "trellis-components": "/trellis-components/static-1.2279",
      "ui-fonts": "/ui-fonts/static-1.894",
      "usage-tracker-container": "/usage-tracker-container/static-1.7503",
      "usage-tracker-core": "/usage-tracker-core/static-1.7363",
      "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4523",
      "floating-ui": "/floating-ui/static-1.59",
      "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2314",
      "hs-story-utils": "/hs-story-utils/static-1.9585",
      "react-create-root-preference": "/react-create-root-preference/static-1.41",
      "tanstack-table": "/tanstack-table/static-1.57",
      "trellis-assets": "/trellis-assets/static-1.2260",
      "ui-images": "/ui-images/static-2.1198",
      "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3081",
      "foundations-theming-base": "/foundations-theming-base/static-1.3583",
      "stylex": "/stylex/static-1.36",
      "HubStyle": "/HubStyle/static-2.11939",
      "sassPrefix": "/sassPrefix/static-1.159",
      "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3963",
      "property-translator": "/property-translator/static-1.5557",
      "react-dnd-compat": "/react-dnd-compat/static-1.4775",
      "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
      "ai-components-ui-library": "/ai-components-ui-library/static-1.9375",
      "audio-components": "/audio-components/static-1.6166",
      "ContentUtils": "/ContentUtils/static-1.68858",
      "cropperjs": "/cropperjs/static-1.10",
      "feedback-loader": "/feedback-loader/static-1.29605",
      "file-manager-components": "/file-manager-components/static-1.24109",
      "FileManagerImages": "/FileManagerImages/static-1.37260",
      "foundations-components-legacy": "/foundations-components-legacy/static-1.1279",
      "html-to-image": "/html-to-image/static-1.56",
      "immerable": "/immerable/static-1.4312",
      "react-colorpicker": "/react-colorpicker/static-2.10370",
      "redux-toolkit": "/redux-toolkit/static-1.7",
      "ui-universal-auth": "/ui-universal-auth/static-1.9170",
      "urlinator": "/urlinator/static-1.4695",
      "video-components": "/video-components/static-1.13832",
      "video-data-lib": "/video-data-lib/static-1.35488",
      "video-embed": "/video-embed/static-1.36322",
      "redux-thunk": "/redux-thunk/static-2.43",
      "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.499",
      "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.231",
      "chirp-fetch": "/chirp-fetch/static-1.2050",
      "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10375",
      "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10373",
      "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5199",
      "web-vitals": "/web-vitals/static-1.8",
      "base-ui": "/base-ui/static-1.16",
      "react-day-picker": "/react-day-picker/static-1.5",
      "trellis-theming": "/trellis-theming/static-1.1109",
      "tanstack-virtual": "/tanstack-virtual/static-1.32",
      "react-dnd": "/react-dnd/static-5.6",
      "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
      "autolinker": "/autolinker/static-3.11",
      "chatspot-core": "/chatspot-core/static-1.22130",
      "copilot-toolkit": "/copilot-toolkit/static-1.11564",
      "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13191",
      "sanitize": "/sanitize/static-1.4638",
      "sanitize-text": "/sanitize-text/static-1.8308",
      "content-assistance-lib": "/content-assistance-lib/static-1.8009",
      "usage-tracker": "/usage-tracker/static-1.7513",
      "cms-field-types": "/cms-field-types/static-1.4975",
      "content-icons-ui": "/content-icons-ui/static-1.2274",
      "integrations-lib": "/integrations-lib/static-1.16695",
      "underscore": "/underscore/static-1.8",
      "breeze-engine-lib": "/breeze-engine-lib/static-1.1309",
      "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9239",
      "video-components-external": "/video-components-external/static-1.11830",
      "unified-auth-core-lib": "/unified-auth-core-lib/static-1.966",
      "social-insights-client-types": "/social-insights-client-types/static-1.22517",
      "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
      "outpost": "/outpost/static-1.4330",
      "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
      "markdown-it": "/markdown-it/static-1.6",
      "magpie-lib": "/magpie-lib/static-1.5658",
      "magpie-types": "/magpie-types/static-1.5118",
      "simple-logging-lib": "/simple-logging-lib/static-1.3210",
      "atom": "/atom/static-1.5236",
      "avatar-components": "/avatar-components/static-1.2661",
      "reference-resolvers": "/reference-resolvers/static-1.8337",
      "superstore": "/superstore/static-1.4921",
      "ui-addon-video-player": "/ui-addon-video-player/static-1.8866",
      "ui-coaching-tips": "/ui-coaching-tips/static-1.29030",
      "flux-actions": "/flux-actions/static-1.350",
      "frontend-preferences-client": "/frontend-preferences-client/static-1.8089",
      "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14110",
      "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5769",
      "laboratory-lib": "/laboratory-lib/static-3.7312",
      "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7941",
      "redux-observable": "/redux-observable/static-1.11",
      "ReduxMessenger": "/ReduxMessenger/static-2.10524",
      "rxjs": "/rxjs/static-5.10",
      "ui-addon-i18n": "/ui-addon-i18n/static-1.11310",
      "ui-shepherd-react": "/ui-shepherd-react/static-3.10420",
      "unified-auth": "/unified-auth/static-1.684",
      "breeze-engine-core": "/breeze-engine-core/static-1.587",
      "ably": "/ably/static-2.2",
      "highlight.js": "/highlight.js/static-1.81",
      "navigation-messaging": "/navigation-messaging/static-1.7785",
      "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.12851",
      "content-media-compositions": "/content-media-compositions/static-2.16858",
      "idb-keyval": "/idb-keyval/static-1.46",
      "media-bridge-lib": "/media-bridge-lib/static-1.19216",
      "fsm": "/fsm/static-1.3891",
      "reactive-lib": "/reactive-lib/static-1.887",
      "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6740",
      "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3173",
      "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5737",
      "adobe-sign-auth-lib": "/adobe-sign-auth-lib/static-1.174",
      "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.652",
      "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.739",
      "microsoft-drive-integration-lib": "/microsoft-drive-integration-lib/static-1.878",
      "surveymonkey-integration-lib": "/surveymonkey-integration-lib/static-1.192",
      "slack-ui-library": "/slack-ui-library/static-1.10558",
      "js-cookie": "/js-cookie/static-1.18",
      "react-dlb": "/react-dlb/static-1.82",
      "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3702",
      "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7057",
      "location-customization-utils-lib": "/location-customization-utils-lib/static-1.9753",
      "batch-promise": "/batch-promise/static-1.1705",
      "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3914",
      "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4254",
      "fdsr-migration-layer": "/fdsr-migration-layer/static-1.176",
      "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4122",
      "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6962",
      "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3704",
      "multi-currency-client-types": "/multi-currency-client-types/static-1.3808",
      "persist-promise": "/persist-promise/static-1.3862"
    },
    "bundlingPackage": "conversations-embed",
    "bundlingPackageVersion": "static-1.27523",
    "project": "conversations-embed",
    "staticDomain": "//static.hsappstatic.net",
    "staticDomainPrefix": "//static.hsappstatic.net"
  }
};